<script setup>
import LogoModal from '@/components/modal/LogoModal.vue';
import pages from './pages';
import SendCode from './SendCode.vue';
import SignIn from './SignIn.vue';
import AppointmentSchedule from './AppointmentSchedule.vue';
import ScheduleConfirmed from './ScheduleConfirmed.vue';
import RescheduleCancel from './RescheduleCancel.vue';
import CancelConfirmed from './CancelConfirmed.vue';

defineProps({
  event: Object,
  appointmentsAvailable: Boolean,
  currentPage: String,
  statuses: Object,
  email: String,
  verification: String,
  user: Object,
  session: Object,
  isExpiredLink: Boolean,
  serverErrorMessage: String,
});

const emit = defineEmits(['send-code', 'send-again', 'sign-in', 'schedule', 'close']);

const sendCode = (email) => emit('send-code', email);
const signIn = (code) => emit('sign-in', code);
const sendAgain = () => emit('send-again');
const schedule = (payload) => emit('schedule', payload);
const reschedule = (payload) => emit('reschedule', payload);
const cancel = (payload) => emit('cancel', payload);
const close = () => emit('close');

// TODO - check appointment count on modal open
</script>
<template>
  <logo-modal @close="close">
    <template v-slot:body>
      <div class="px-[2.5rem] tablet:px-[4rem]">
        <template v-if="!appointmentsAvailable">
          <p class="py-14">
            Thank you for your interest in Ford Pro™.
            At the moment all appointment timeslots are full.
            Please visit the Ford Pro™ booth to interact with the team,
            even without an appointment.
          </p>
        </template>
        <template v-else>
          <SendCode class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="currentPage === pages.sendCode"
            :event="event"
            @send-code="sendCode"
            :is-expired-link="isExpiredLink"
            :statuses="{sendCodeStatus: statuses.sendCodeStatus}" />
          <SignIn class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="(currentPage === pages.signIn)"
            @sign-in="signIn"
            @send-again="sendAgain"
            :event="event"
            :statuses="{signInStatus: statuses.signInStatus}"
            :email="email"
          />
          <AppointmentSchedule class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="(currentPage === pages.appointmentSchedule)"
            :event="event"
            :session="session"
            :auth-email="email"
            :auth-verification="verification"
            @schedule="schedule"
            :statuses="{scheduleStatus: statuses.scheduleStatus}"
            :server-error-message="serverErrorMessage"
          />
          <ScheduleConfirmed class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="currentPage === pages.scheduleConfirmed"
            :event="event"
            :firstName="user.firstName"
            @close="close"
          />
          <RescheduleCancel class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="(currentPage === pages.rescheduleCancel)"
            :event="event"
            :statuses="{cancelStatus: statuses.cancelStatus}"
            @reschedule="reschedule"
            @cancel="cancel"
            @close="close"
          />
          <CancelConfirmed class="mt-[1.875rem] tablet:mt-[4.5rem]"
            v-if="(currentPage === pages.cancelConfirmed)"
            :event="event"
            @close="close"
          />
        </template>
      </div>
    </template>
  </logo-modal>
</template>
